import GeckoRequest from 'services/gecko-request';
import { reduxStore } from 'services/gecko-store/redux';

const dispatch = (event, payload = {}, metadata = {}) => {
  return reduxStore.dispatch({
    type: event,
    payload,
    metadata,
  });
};

export const fetchExports = () => {
  return GeckoRequest.get(`/exports`)
    .then((payload) => {
      dispatch('FETCHED_EXPORTS', payload);
    })
    .catch((err) => {
      dispatch('FAILED_EXPORTS', { error: err });
      return Promise.reject(err);
    });
};
